import { TreeGridTranslations } from "../../hooks/use-translations"
import { updateRowCountInToolbar } from "./utils"

type MakeOnSearchChangeArgs = {
  translations: TreeGridTranslations
}

const normalizeQuery = (query: unknown): string => {
  if (!query) return ""
  if (typeof query === "string") return query.trim()
  return String(query).trim()
}

export const makeOnSearchChange = (args: MakeOnSearchChangeArgs) => (grid: TGrid, searchQuery: string) => {
  const query = normalizeQuery(searchQuery)
  if (!grid) return // No-op if grid is not initialized

  const { translations } = args

  grid.SearchExpression = query
  grid.StandardFilter = 2
  grid.DoSearch("Filter")
  updateRowCountInToolbar(grid, translations.toolbarTaskListSummaryText)
}
